export default __webpack_public_path__ + "static/media/logo.d12725d5.svg";